import uc from '@/api/uc.js'
import { Base64 } from 'js-base64'

const state = {
  currentUser: JSON.parse(sessionStorage.getItem('currentUser')) || null,
  loginAccount: null,
  tenantName: '',
  token: sessionStorage.getItem('token'),
  refreshToken: sessionStorage.getItem('refreshToken'),
  tokenV2: sessionStorage.getItem('tokenV2'),
  htmlSrc: ''
}

const getters = {}

const actions = {
  actionLoginAccount({ commit, state }, loginAccount) {
    commit('mutationLoginAccount', loginAccount)
  },
  loginByPrincipal({ commit, state }, principal) {
    return new Promise((resolve, reject) => {
      uc.authentication(
        principal,
        (response) => {
          if (response && response.state) {
            sessionStorage.setItem('loginRequest', JSON.stringify(principal))
            sessionStorage.setItem('loginResp', JSON.stringify(response.value))
            sessionStorage.setItem('tenantId', principal.tenantId)
            commit('mutationToken', response.value.access_token)
            commit('mutationRefreshToken', response.value.refresh_token)
            resolve(true)
          }
          // if (user) {
          //   sessionStorage.setItem("currentUser", JSON.stringify(user));
          //   sessionStorage.setItem("tenantId", principal.tenantId);
          //   commit("setCurrentUser", user);
          //   resolve(user.loginStatus);
          // }
        },
        (msg) => {
          commit('clearCurrentUser')
          reject(msg)
        }
      )
    })
  },
  loginV2Token({ commit, state }, account) {
    return new Promise((resolve, reject) => {
      uc.getTokenV2ByUserName(
        account,
        (resp) => {
          commit('setTokenV2', resp.value)
          resolve()
        },
        (msg) => {
          commit('clearTokenV2')
          reject(msg)
        }
      )
    })
  },
  /**
   * 用户信息
   * @param data 账号数据
   */
  setCurUser({ commit, state }, account) {
    return new Promise((resolve, reject) => {
      uc.loadUserByUsername(account, (response) => {
        if (response) {
          // this.currentUser = response
          let currentUser = {
            tenantId: response.tenantId,
            account: response.account,
            token: state.token,
            userAttrs: response.attributes,
            userId: response.userId,
            username: response.fullname,
            loginStatus: true,
            overTime: '120'
          }
          commit('setCurrentUser', currentUser)
          resolve(currentUser)
        }
      })
    })
  },
  validAndCompletedCurrent({ commit, state }, token) {
    return new Promise((resolve, reject) => {
      if (state.currentUser && !token) {
        resolve()
      } else {
        const user = sessionStorage.getItem('currentUser')
        if (user != 'null' && user != undefined && user != '' && !token) {
          commit('setCurrentUser', JSON.parse(user))
          resolve()
        } else if (token) {
          let loginUser = JSON.parse(Base64.decode(token))
          let params = {
            tenantId: loginUser.tenantId,
            base64: encodeURIComponent(token),
            grant_type: 'base64',
            account_type: 'evo'
          }
          uc.authentication(
            params,
            (response) => {
              if (response && response.state) {
                sessionStorage.setItem('loginRequest', JSON.stringify(params))
                sessionStorage.setItem('loginResp', JSON.stringify(response.value))
                sessionStorage.setItem('tenantId', params.tenantId)
                commit('mutationToken', response.value.access_token)
                resolve(true)
              }
            },
            (msg) => {
              commit('clearCurrentUser')
              reject(msg)
            }
          )
        } else {
          reject()
        }
      }
    })
  },
  logoutAndCleanUp({ commit, state }) {
    return new Promise((resolve, reject) => {
      sessionStorage.removeItem('currentUser')
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('tokenV2');
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('loginResp');
      localStorage.removeItem('activeAlias')
      commit('clearCurrentUser')
      commit('user/setCurrentUserDetail', null, { root: true })
      resolve()
    })
  },
  loginTenantName({ commit, state }, tenantName) {
    commit('handleTenantName', tenantName)
  },
  getHtmlSrc({ commit, state }, instance) {
    commit('handleGetHtmlSrc', instance)
  },
  saveHtmlSrc({ commit, state }, instance) {
    return new Promise((resolve, reject) => {
      if (state.currentUser) {
        uc.getTicket(state.currentUser.userId).then((resp) => {
          if (resp) {
            let htmlSrc =
              window.context.front3 +
              '/formManage/manage?ticket=' +
              resp +
              '&account=' +
              state.currentUser.account +
              '&tenantId=' +
              state.currentUser.tenantId +
              '&formKey=' +
              instance
            resolve(htmlSrc)
          }
        })
      } else {
        reject()
      }
    })
  }
}

const mutations = {
  handleGetHtmlSrc(state, instance) {
    if (state.currentUser) {
      uc.getTicket(state.currentUser.userId).then((resp) => {
        if (resp) {
          state.htmlSrc =
            window.context.front3 +
            '/formManage/manage?ticket=' +
            resp +
            '&account=' +
            state.currentUser.account +
            '&tenantId=' +
            state.currentUser.tenantId +
            '&fromData=' +
            Base64.encode(
              JSON.stringify({
                instance_id: instance.id,
                taskId: instance.taskId,
                procDefKey: instance.procDefKey
              })
            )
        }
      })
    }
  },
  setCurrentUser(state, current) {
    state.currentUser = current
    sessionStorage.setItem('currentUser', JSON.stringify(current))
  },
  clearCurrentUser(state) {
    state.currentUser = null
  },
  mutationLoginAccount(state, loginAccount) {
    state.loginAccount = loginAccount
    sessionStorage.setItem('loginAccount', loginAccount)
  },
  mutationToken(state, token) {
    state.token = token
    sessionStorage.setItem('token', token)
  },
  mutationRefreshToken(state, refreshToken) {
    state.refreshtoken = refreshToken
    sessionStorage.setItem('refreshToken', refreshToken)
  },
  setTokenV2(state, token) {
    state.tokenV2 = token
    sessionStorage.setItem('tokenV2', token)
  },
  clearTokenV2(state) {
    state.tokenV2 = null
  },
  handleTenantName(state, tenantName) {
    state.tenantName = tenantName
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
